var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"storenotecard"},[_c('div',{style:({
      background: _vm.datas.backColor,
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[(_vm.datas.styleType !== 3)?_c('section',{staticClass:"goods_list_con",class:[
        _vm.datas.styleType === 1 || _vm.datas.styleType === 4
          ? 'goods_list_con1'
          : _vm.datas.styleType === 5
          ? 'goods_list_con5'
          : 'goods_list_con3',
      ],staticStyle:{"display":"flex"}},[_c('div',{staticClass:"goods_item_con",on:{"click":function($event){return _vm.handleClickImg(_vm.datas)}}},[_c('div',{staticClass:"goods_img_con"},[_c('img',{attrs:{"draggable":"false","src":_vm.datas.firstImgUrl ? _vm.datas.firstImgUrl : _vm.defaultImg,"alt":""}})]),_c('div',{class:[
            {
              goods_info_con4: _vm.datas.styleType === 4 || _vm.datas.styleType === 5,
            },
            'goods_info_con',
          ],style:({ 'background-color': _vm.datas.titleBgColor })},[_c('div',{staticClass:"name_con",style:({
              color: _vm.datas.wordColorTitle,
              'font-size': _vm.datas.wordSizeTitle + 'px',
              'font-weight': _vm.datas.isBoldTitle ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltTitle ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineTitle
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.title)+" ")]),_c('div',{style:({
              color: _vm.datas.wordColorDesc,
              'font-size': _vm.datas.wordSizeDesc + 'px',
              'font-weight': _vm.datas.isBoldDesc ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltDesc ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineDesc ? 'underline' : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.descTitle)+" ")])])]),(_vm.datas.styleType == 2 || _vm.datas.styleType == 5)?_c('div',{staticClass:"goods_item_con",on:{"click":function($event){return _vm.handleClickImg(_vm.datas.link2Obj)}}},[_c('div',{staticClass:"goods_img_con"},[_c('img',{attrs:{"draggable":"false","src":_vm.datas.secondImgUrl ? _vm.datas.secondImgUrl : _vm.defaultImg,"alt":""}})]),_c('div',{class:[
            { goods_info_con4: _vm.datas.styleType === 5 },
            'goods_info_con',
          ],style:({ 'background-color': _vm.datas.titleBgColor2 })},[_c('div',{staticClass:"name_con",style:({
              color: _vm.datas.wordColorTitle2,
              'font-size': _vm.datas.wordSizeTitle2 + 'px',
              'font-weight': _vm.datas.isBoldTitle2 ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltTitle2 ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineTitle2
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.title2)+" ")]),_c('div',{style:({
              color: _vm.datas.wordColorDesc2,
              'font-size': _vm.datas.wordSizeDesc2 + 'px',
              'font-weight': _vm.datas.isBoldDesc2 ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltDesc2 ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineDesc2
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.descTitle2)+" ")])])]):_vm._e()]):_vm._e(),(_vm.datas.styleType === 3)?_c('section',{staticClass:"goods_list_con goods_list_con2"},[_c('div',{staticClass:"goods_item_con",on:{"click":function($event){return _vm.handleClickImg(_vm.datas)}}},[_c('div',{staticClass:"goods_img_con"},[_c('img',{attrs:{"draggable":"false","src":_vm.datas.firstImgUrl ? _vm.datas.firstImgUrl : _vm.defaultImg,"alt":""}})]),_c('div',{class:['goods_info_con'],style:({ 'background-color': _vm.datas.titleBgColor })},[_c('div',{staticClass:"name_con",style:({
              color: _vm.datas.wordColorTitle,
              'font-size': _vm.datas.wordSizeTitle + 'px',
              'font-weight': _vm.datas.isBoldTitle ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltTitle ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineTitle
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.title)+" ")]),_c('div',{style:({
              color: _vm.datas.wordColorDesc,
              'font-size': _vm.datas.wordSizeDesc + 'px',
              'font-weight': _vm.datas.isBoldDesc ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltDesc ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineDesc ? 'underline' : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.descTitle)+" ")])])]),_c('div',{staticClass:"goods_item_con",on:{"click":function($event){return _vm.handleClickImg(_vm.datas.link2Obj)}}},[_c('div',{staticClass:"goods_img_con"},[_c('img',{attrs:{"draggable":"false","src":_vm.datas.secondImgUrl ? _vm.datas.secondImgUrl : _vm.defaultImg,"alt":""}})]),_c('div',{class:['goods_info_con'],style:({ 'background-color': _vm.datas.titleBgColor2 })},[_c('div',{staticClass:"name_con",style:({
              color: _vm.datas.wordColorTitle2,
              'font-size': _vm.datas.wordSizeTitle2 + 'px',
              'font-weight': _vm.datas.isBoldTitle2 ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltTitle2 ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineTitle2
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.title2)+" ")]),_c('div',{style:({
              color: _vm.datas.wordColorDesc2,
              'font-size': _vm.datas.wordSizeDesc2 + 'px',
              'font-weight': _vm.datas.isBoldDesc2 ? 'bold' : 'normal',
              'font-style': _vm.datas.isTiltDesc2 ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLineDesc2
                ? 'underline'
                : 'none',
            })},[_vm._v(" "+_vm._s(_vm.datas.descTitle2)+" ")])])])]):_vm._e()]),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }